import { CALL_API, Schemas } from '../../common/middleware/api';

export const NOTES_REQUEST = 'NOTES_REQUEST';
export const NOTES_SUCCESS = 'NOTES_SUCCESS';
export const NOTES_FAILURE = 'NOTES_FAILURE';

export const NOTE_CREATE_REQUEST = 'NOTE_CREATE_REQUEST';
export const NOTE_CREATE_SUCCESS = 'NOTE_CREATE_SUCCESS';
export const NOTE_CREATE_FAILURE = 'NOTE_CREATE_FAILURE';

export const NOTE_DELETE_REQUEST = 'NOTE_DELETE_REQUEST';
export const NOTE_DELETE_SUCCESS = 'NOTE_DELETE_SUCCESS';
export const NOTE_DELETE_FAILURE = 'NOTE_DELETE_FAILURE';

export const loadNotes = ({ reference, referenceType, ...options }) => ({
	[CALL_API]: {
		types: [NOTES_REQUEST, NOTES_SUCCESS, NOTES_FAILURE],
		endpoint: 'api/notes',
		request: { reference, referenceType, ...options },
		schema: Schemas.NOTE_ARRAY
	},
	reference,
	referenceType
});

export const createNote = (note, onSuccessEvent) => ({
	[CALL_API]: {
		types: [NOTE_CREATE_REQUEST, NOTE_CREATE_SUCCESS, NOTE_CREATE_FAILURE],
		endpoint: 'api/notes',
		method: 'POST',
		request: note,
		schema: Schemas.NOTE,
		form: 'note',
		onSuccessEvent
	}
});

export const deleteNote = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [NOTE_DELETE_REQUEST, NOTE_DELETE_SUCCESS, NOTE_DELETE_FAILURE],
		endpoint: `api/notes/${id}`,
		method: 'DELETE',
		onSuccessEvent
	}
});